/**
 * 
 * HomeCarousel.js
 * 
 */
export default class HomeCarousel {

    constructor() {
        this.name = 'HomeCarousel';
        this.homeCarousel = document.querySelector('.main-carousel');
        this.flkty;

        this._init();
    }

    // Public Functions
    restartFlickity() {
        if (this.homeCarousel) {
            this._unwrap(document.querySelector('.dots-wrapper'));
            document.querySelector('.previous-btn').outerHTML = "";
            document.querySelector('.next-btn').outerHTML = "";
            this.flkty.destroy();
            this._init();
        }
    }
    
    // 'Private' Functions
    _init() {
        if (this.homeCarousel) {
            this.flkty = new Flickity(this.homeCarousel, {
                // options
                autoPlay: true,
                wrapAround: true
            });
    
            // Wrap Flickity Dots in a div, so I can add Prev Next buttons
            let dotsList = document.querySelector('.flickity-page-dots');
            let dotsWrapper = document.createElement('div');
            dotsWrapper.classList.add('dots-wrapper');
            dotsList.parentNode.insertBefore(dotsWrapper, dotsList);
            dotsWrapper.appendChild(dotsList);
    
            // Add Prev / Next Arrows
            let prevBtn = document.createElement("div");
            prevBtn.classList.add('previous-btn');
    
            let nextBtn = document.createElement("div");
            nextBtn.classList.add('next-btn');
    
            dotsWrapper.insertBefore(prevBtn, dotsWrapper.childNodes[0]);
            dotsWrapper.appendChild(nextBtn);
    
            prevBtn.addEventListener('click', _handleCarouselPrevNext.bind(this));
            nextBtn.addEventListener('click', _handleCarouselPrevNext.bind(this));
    
            function _handleCarouselPrevNext(e) {
                e.preventDefault();
                let btn = e.target;
                if (btn.classList.contains('previous-btn')) {
                    this.flkty.previous(true);
                }
                if (btn.classList.contains('next-btn')) {
                    this.flkty.next(true);
                }
            }
        }
    }

    _unwrap(wrapper) {
        // place childNodes in document fragment
        var docFrag = document.createDocumentFragment();
        while (wrapper.firstChild) {
            var child = wrapper.removeChild(wrapper.firstChild);
            docFrag.appendChild(child);
        }
    
        // replace wrapper with document fragment
        wrapper.parentNode.replaceChild(docFrag, wrapper);
    }
}
